<template>
    <div class="content">
        <div class="container-fluid">
          <div class="row align-items-center mb-1">
            <div class="col-md-6">
              <div class="h2">Staff</div>
            </div>
            <div class="col-md-2 offset-md-2 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="$router.push({ name: 'PersonOrdering'})">Change List Order</button>
            </div>
            <div class="col-md-2 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="createPerson">Add Member</button>
            </div>
          </div>
            <!--<div class="row align-items-center mb-1">-->
                <!--<div class="col-md-6">-->
                    <!--<div class="h2">Greetings Board</div>-->
                <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                <!--<button type="submit" class="btn btn-primary btn-fill" @click="createGreeting">Create Greeting</button>-->
              <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                    <!--<button type="button" class="btn btn-primary btn-fill" @click="$router.push({ name: 'Greeting Ordering'})">Order Greeting</button>-->
                <!--</div>-->
            <!--</div>-->
            <div class="table-responsive text-center">
                <l-table class="table table-light  table-light table-bordered table-hover"
                         :columns="persons.columns" :data="persons.data">
                    <template slot="table-row" v-if="persons.data.length">
                        <tr v-for="(item, index) in persons.data" :key="index" :class="{'inactive': item.status === '0'}">
                            <td>{{item.staffId}}</td>
                            <td>{{item.memberFirstName}}</td>
                            <td><img class="table-thumbnail" :title="item.memberFirstName":src="item.memberImageUrl" /></td>
                            <td>{{item.position}}</td>
                            <td>
                                <span class="badge badge-success" v-if="item.active != '0'"> Active </span>
                                <span class="badge badge-danger" v-else> Inactive </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <button class="btn btn-secondary btn-sm" @click="viewPerson(item)" v-tooltip.top-center="persons.tooltips.view"><i class="fa fa-eye"></i></button>
                                    <button class="btn btn-info btn-sm" @click="editPerson(item)" v-tooltip.top-center="persons.tooltips.edit"><i class="fa fa-edit"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const personsColumns = ['Member Id', 'Member Name','Image', 'Designation', 'Status', 'Operations'];
    export default {
        name: 'Persons',
        components: {
            LTable,
        },
        data() {
        return {
              persons: {
                tooltips: {
                    view: 'View Person',
                    edit: 'Edit Person',
                    delete: 'Inactivate Person',
                    activate:'Activate Person',
                },
                columns: [...personsColumns],
        tableRowClass: {
            classname: 'badge-warning',
                    classActiveCondition: 'status'
        },
        data: []
    }
    }
    },
    methods: {
        fetchPersons () {
            this.$store.dispatch('FETCH_PERSONS')
                    .then((res) => {
                        this.persons.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        },
        viewPerson(person){
            this.$router.push({ name: 'PersonDetail', params: { id: person.staffId}})
        },
        editPerson(person){
            this.$router.push({ name: 'EditPerson', params: { id: person.staffId}})
        },
        createPerson(){
            this.$router.push({ name: 'CreatePerson'})
        },
        deleteTestimonial(testimonial, boolean){
            console.log("testimonial : ", testimonial);
            this.$store.dispatch('DELETE_SELECTED_TESTIMONIAL', {testimonialId: testimonial.pkCarouselId})
                    .then((res) => {
                        console.log("DELETE_SELECTED_EXPERT API res : ", res);
                        this.fetchTestimonials();
                    })
                    .catch(err => {
                        console.log("DELETE_SELECTED_EXPERT API error : ", err);
                    })
        }
    },
    created() {
        this.fetchPersons();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Persons/Persons.vue